import { restartSubscription } from "@/controllers/subscription";
import { effectiveCheckoutParams } from "@/lib/checkoutIntent";
import { isOrtexApp } from "@/lib/utils";
import { useCallback } from "react";
import useHandleAppUpgrade from "./useHandleAppUpgrade";
import { useSetRecoilState } from "recoil";
import { paymentModalOpenState, planState, subscriptionState } from "@/lib/store";
import useApplyPromoCode from "./useApplyPromoCode";
import { useRouter } from "next/router";

const useOpenSubscriptionForm = () => {
    const { handleAppUpgrade } = useHandleAppUpgrade();
    const setSubscription = useSetRecoilState(subscriptionState);
    const setPaymentModalOpen = useSetRecoilState(paymentModalOpenState);
    const setPlan = useSetRecoilState(planState);
    const { applyPromoCode } = useApplyPromoCode();

    const { query } = useRouter();

    const openSubscriptionForm = useCallback(
        (shouldOpen: any = true, selectedPackage?: any) => {
            if (!shouldOpen) return;
            if (isOrtexApp()) {
                handleAppUpgrade(selectedPackage);
            } else {
                // URL query wins; the persisted checkout intent fills the gaps so
                // t/v/promo from a shared link survive the signup / /upgrade hops
                // that strip the query string.
                const eff = effectiveCheckoutParams(query);
                const interval = eff.t === "monthly" ? "monthly" : eff.t === "annual" || eff.t === "annually" ? "annually" : (query.pt as string) === "m" ? "monthly" : "annually";
                const tier = eff.v === "basic" ? "Basic" : "Advanced";
                setSubscription(null);
                setPaymentModalOpen(true);
                const promoFromSession = sessionStorage.getItem("promoCode");
                const currentPromo = eff.promo ? eff.promo : promoFromSession && promoFromSession !== "true" ? promoFromSession : null;
                currentPromo
                    ? applyPromoCode(currentPromo)
                    : restartSubscription().then((res) => {
                          // Null / plan-less responses (anonymous visitor, error paths)
                          // are normalised by restartSubscription — skip instead of crashing.
                          if (!res || !Array.isArray(res.plans)) return;
                          setSubscription(res);
                          setPlan(res.plans.find((plan) => plan.product_name.includes(tier) && plan.plan_interval === interval));
                      });
            }
        },
        [handleAppUpgrade, query]
    );
    return { openSubscriptionForm };
};

export default useOpenSubscriptionForm;
